import React from "react";
import { useTranslation } from "react-i18next";
import "./WhyChooseStyle.css";
import image1 from "../../assets/app.jpg";
import image2 from "../../assets/oth.jpg";
import image3 from "../../assets/custom.jpg";

const WhyChoose = ({ id }) => {
  const { t } = useTranslation();

  return (
    <section className="why-choose-section" id={id}>
      <div className="why-choose-container">
        <div className="why-choose-content">
          <h2 className="why-choose-subtitle">{t("whyChoose.subtitle")}</h2>
          <h1 className="why-choose-title">{t("whyChoose.title")}</h1>
          <p className="why-choose-description">{t("whyChoose.description")}</p>
          <div className="why-choose-features">
            <div className="why-choose-feature">
              <h3>{t("whyChoose.features.experienced.title")}</h3>
              <p>{t("whyChoose.features.experienced.description")}</p>
            </div>
            <div className="why-choose-feature">
              <h3>{t("whyChoose.features.advanced.title")}</h3>
              <p>{t("whyChoose.features.advanced.description")}</p>
            </div>
            <div className="why-choose-feature">
              <h3>{t("whyChoose.features.personalized.title")}</h3>
              <p>{t("whyChoose.features.personalized.description")}</p>
            </div>
            <div className="why-choose-feature">
              <h3>{t("whyChoose.features.family.title")}</h3>
              <p>{t("whyChoose.features.family.description")}</p>
            </div>
          </div>
        </div>
        <div className="why-choose-images">
          <img
            src={image1}
            alt={t("whyChoose.image1Alt")}
            className="why-choose-image top-image"
          />
          <img
            src={image2}
            alt={t("whyChoose.image2Alt")}
            className="why-choose-image bottom-image"
          />
          <img
            src={image3}
            alt={t("whyChoose.image3Alt")}
            className="why-choose-image side-image"
          />
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
